import {
  BrandName,
  SupportedCountryCode
} from '@seek/je-shared-data/lib/types/brand';

interface HireFaster {
  brand: BrandName;
  country: SupportedCountryCode;
}
/**
 * Determines whether to show the benefit for "Hire candidates faster".
 *
 * @param {BrandName} params.brand - The brand name.
 * @param {SupportedCountryCode} params.country - The country code.
 * @returns {boolean} Returns true if the benefit should be shown, false
 * otherwise.
 */
export const showHireCandidatesFaster = ({
  brand,
  country
}: HireFaster): boolean => {
  if (brand !== BrandName.JOBSTREETEXPRESS) return false;
  if (
    country === SupportedCountryCode.Singapore ||
    country === SupportedCountryCode.Indonesia
  ) {
    return false;
  }

  return false;
};
